export default "<p>attribute works!</p>\r\n";